import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PATH } from "../../router/path";
import Condition from "../Conditional/Condition";
import CustomIconButton from "../elements/IconButton/CustomIconButton";

interface INavigationBack {
	onClick?: () => void;
	hideBack?: boolean;
}

const NavigationBack: React.FC<INavigationBack> = ({ onClick, hideBack }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;

	const handleBackButtonOnClick = useCallback(() => {
		switch (currentPath) {
			case PATH.CART:
				return navigate(PATH.PRODUCT_LIST);
			case PATH.PAYMENT:
				// Pops the history guard the payment page pushed over the real history; the
				// guard's popstate handler owns the exit — clearing the abandoned order and
				// landing in the cart with a replace. Pushing the cart on top instead left
				// the guard entry behind for a later browser-back to flash through.
				return navigate(-1);
			case PATH.SEND_TO_KITCHEN_CONFIRM:
				return navigate(PATH.CART);
			case PATH.BILL:
				return navigate(PATH.PRODUCT_LIST);
			default:
				return navigate(-1);
		}
	}, [navigate, currentPath]);

	return (
		<div data-testid="NavigationBackCntr" className="NavigationBackCntr">
			<Condition check={hideBack}>
				<div className="NavigationBackPlaceHolder" />
			</Condition>
			<Condition check={!hideBack}>
				<CustomIconButton
					aria-label="go back"
					data-testid="NavigationBackIconButton"
					onClick={onClick ?? handleBackButtonOnClick}
				>
					<ArrowBackIosIcon />
				</CustomIconButton>
			</Condition>
		</div>
	);
};

export default React.memo(NavigationBack);
